var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0176 13.8757C12.6598 13.8757 13.9911 12.5445 13.9911 10.9023C13.9911 9.26009 12.6598 7.92883 11.0176 7.92883C9.37544 7.92883 8.04419 9.26009 8.04419 10.9023C8.04419 12.5445 9.37544 13.8757 11.0176 13.8757Z",
    fill: "#003049"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04419 17.8412C8.04419 16.7464 8.93171 15.8589 10.0265 15.8589H12.0088C13.1036 15.8589 13.9911 16.7464 13.9911 17.8412V33.6996C13.9911 34.7944 13.1036 35.6819 12.0088 35.6819H10.0265C8.93171 35.6819 8.04419 34.7944 8.04419 33.6996V17.8412Z",
    fill: "#003049"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9381 35.6819H21.9204C23.0152 35.6819 23.9027 34.7944 23.9027 33.6996V24.7793C23.9027 21.8058 29.8496 19.8235 29.8496 23.7881V33.7004C29.8496 34.7952 30.7371 35.6819 31.8319 35.6819H33.8142C34.9091 35.6819 35.7965 34.7944 35.7965 33.6996V21.8058C35.7965 17.8412 32.8231 15.8589 28.8585 15.8589C24.8939 15.8589 23.9027 18.8323 23.9027 18.8323V17.8412C23.9027 16.7464 23.0152 15.8589 21.9204 15.8589H19.9381C18.8433 15.8589 17.9558 16.7464 17.9558 17.8412V33.6996C17.9558 34.7944 18.8433 35.6819 19.9381 35.6819Z",
    fill: "#003049"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.779 0.00012207C41.0635 0.00012207 43.7259 2.66265 43.7259 5.94703V37.6639C43.7259 40.9484 41.0635 43.6108 37.779 43.6108H6.06214C2.77777 43.6108 0.115234 40.9484 0.115234 37.6639V5.94703C0.115234 2.66265 2.77777 0.00012207 6.06214 0.00012207H37.779ZM37.779 3.96473C38.8738 3.96473 39.7613 4.85225 39.7613 5.94703V37.6639C39.7613 38.7587 38.8738 39.6462 37.779 39.6462H6.06214C4.96736 39.6462 4.07984 38.7587 4.07984 37.6639V5.94703C4.07984 4.85225 4.96736 3.96473 6.06214 3.96473H37.779Z",
    fill: "#003049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e4dedefcc3eeb144119e07a521de2897.svg";
export { ForwardRef as ReactComponent };